@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
@import './styles/themes.css';

@tailwind base;
@tailwind components;
@tailwind utilities;

html, body, #root {
  height: 100%;
  margin: 0;
  padding: 0;
  font-family: 'Inter', system-ui, sans-serif;
  /* Transparent in embed mode — bubble and panel paint their own backgrounds.
     Standalone mode sets its own bg via App.tsx wrapper div. */
  background: transparent;
  color: var(--color-text);
}

* {
  box-sizing: border-box;
}